<template lang="pug">
.right_box_main
    // 面包屑导航
    .mianbao
        el-breadcrumb(separator-class='el-icon-arrow-right')
            el-breadcrumb-item(:to="{ path: '/communityServices1' }") 首页
            el-breadcrumb-item 智慧协商
            el-breadcrumb-item 新建议题
    .card-box
        // 右边卡片
        .card-rb
            .card-r(:body-style="{ padding: '16px' }") 
                el-card.card-0
                    .topbarnav
                        img(src='../../../assets/images/icons/13.png', alt='')
                        div 按议题类型查看
                    .onebuttom
                        #chart_1_1
                el-card.card-2
                    .topbarnav
                        img(src='../../../assets/images/icons/4.png', alt='')
                        div 协商来源
                    .onebuttom
                        #chart_1_3
                el-card.card-3
                    .topbarnav
                        img(src='../../../assets/images/icons/3.png', alt='')
                        div 按组织查看
                    .onebuttom
                        #chart_1_2
            .card-4
                el-card(:body-style="{ padding: '16px' }")
                    .fisthang
                        el-form.demo-form-inline(:inline='true', :model='searchlist', size='mini')
                            el-form-item(label='议题内容:', style='margin:0 30 0 0;')
                                el-input(v-model='searchlist.content', placeholder='请输入议题内容', style='width:200px;')
                            el-form-item(label='议题类型:', style='margin:0 30 0 0;')
                                el-select(clearable='', v-model='searchlist.consultType'  placeholder='--请选择--')
                                    el-option(v-for="item in ytlxtList",:key="item.id",:label="item.consultName",:value="item.id") 
                              
                            el-form-item
                                el-button(type='primary', @click='searchlistdata') 查询
                            el-form-item
                                el-button(type='info', @click='searchlistReset') 重置
                    .three
                        el-button(type='primary', size='mini', @click="showDialog('','add')") 议题采集
                        // <el-button type="danger" size="mini">导出Excel</el-button>
                        // 表格盒子
                        .table_card
                            el-table(:data='tableData', :header-cell-style="{ background: '#f8fafa' }", border='', align='center', current-row-key='', highlight-current-row='')
                                el-table-column(align='center', type="index", label="序号", width='60')
                                el-table-column(align='center', prop='streetName', label='镇/街道')
                                el-table-column(align='center', prop='communityId', label='村/社区')
                                    template(scope="scope")
                                        span(v-if="scope.row.communityId == 2") 浔河社区
                                        span(v-if="scope.row.communityId == 20") 石街社区
                                //- el-table-column(align='center', prop='consultName', label='议题名称', :show-overflow-tooltip="true")
                                el-table-column(align='center', prop='content', label='议题的内容',width='160', :show-overflow-tooltip="true")
                                el-table-column(align='center', prop='issueSource', label='协商议题来源',width='160', :show-overflow-tooltip="true")
                                    template(scope="scope")
                                        span(v-if="scope.row.issueSource == 1") 党小组、村(居)民组会议
                                        span(v-if="scope.row.issueSource == 2") 群众通过电话或口头等方式
                                        span(v-if="scope.row.issueSource == 3") 群众通过微信、QQ等方式提出
                                        span(v-if="scope.row.issueSource == 4") 党员议事日
                                        span(v-if="scope.row.issueSource == 5") 意见箱
                                        span(v-if="scope.row.issueSource == 6") 包组干部收集到群众的需求
                                        span(v-if="scope.row.issueSource == 7") 落实上级党委政府工作安排
                                        span(v-if="scope.row.issueSource == 8") 其他
                                el-table-column(align='center', prop='consultTypeName', label='议题类型',width='160',)
                                el-table-column(align='center', prop='bargainingLevel', label='议题层级', :show-overflow-tooltip="true")
                                    template(scope="scope")
                                        span(v-if="scope.row.bargainingLevel == 1") 涉及同一个村"两委"成员包组范围内1个或多个村(居)民组事项
                                        span(v-if="scope.row.bargainingLevel == 2") 涉及1个村以上"两委"成员包组范围内1村(居)民组事项
                                        span(v-if="scope.row.bargainingLevel == 3") 涉及与本镇内1个村以上范围事项
                                        span(v-if="scope.row.bargainingLevel == 4") 涉及本镇以外其他镇的协商事项
                                el-table-column(align='center', prop='createDate', label='创建时间', :show-overflow-tooltip="true")
                                el-table-column(align='center', prop='consultSure', label='议题确定',width='90',)
                                    template(scope="scope")
                                        span(v-if="scope.row.consultSure == 0") 是
                                        span(v-if="scope.row.consultSure == 1") 否
                                el-table-column(align='center', prop='approvalStatus', label='状态',:show-overflow-tooltip="true")
                                    template(scope="scope")
                                        span(v-if="scope.row.approvalStatus == 0") 未交办
                                        span(v-if="scope.row.approvalStatus == 1") 交办
                                        span(v-if="scope.row.approvalStatus == 2") 办理成功
                                        span(v-if="scope.row.approvalStatus == 3") 办理退回
                                        span(v-if="scope.row.approvalStatus == 4") 条件不成熟
                                        span(v-if="scope.row.approvalStatus == 5") 公示审核成功
                                        span(v-if="scope.row.approvalStatus == 6") 公示审核退回
                                        span(v-if="scope.row.approvalStatus == 7") 评议审核成功
                                        span(v-if="scope.row.approvalStatus == 8") 评议审核退回
                                        span(v-if="scope.row.approvalStatus == 9") 直接办理
                                        span(v-if="scope.row.approvalStatus == 10") 评议汇总成功
                                        span(v-if="scope.row.approvalStatus == 11") 已公示
                                        span(v-if="scope.row.approvalStatus == 12") 公示记录成功
                                        span(v-if="scope.row.approvalStatus == 13") 已评议
                                        span(v-if="scope.row.approvalStatus == 14") 暂不协商
                                        span(v-if="scope.row.approvalStatus == 15") 条件不成熟
                                        span(v-if="scope.row.approvalStatus == 16") 议题办理中
                                el-table-column(align='center', label='操作', width='300', fixed='right')
                                    template(slot-scope='scope')
                                        el-tooltip.item(effect='light', content='查看', placement='top-start' v-if="scope.row.approvalStatus != 13")
                                            button.iconfont.icon-chakan.tabBtn(@click="showDialog(scope.row.id,'detail',scope.row)", style='color:#9da09c;')
                                        //- 走完流程后查看 
                                        el-tooltip.item(effect='light', content='查看', placement='top-start' v-if="scope.row.approvalStatus == 13")
                                            button.iconfont.icon-chakan.tabBtn(@click="liucAllShowDialog(scope.row.id,'detail')", style='color:#9da09c;')
                                            //- 审批同意后 不显示
                                        template
                                            el-tooltip.item( v-if="scope.row.approvalStatus == 0"  effect='light', content='编辑', placement='top-start')
                                                button.iconfont.icon-bianji3.tabBtn(@click="showDialog(scope.row.id,'audit',scope.row)", style='color:#199b5d;')
                                            
                                            //- el-tooltip.item(effect='light', content='审批', placement='top-start', style='fontWeight:bold')
                                            //-     button.iconfont.icon-shenhe.tabBtn(@click="showDialog(scope.row.id,'audit')", style='color:#ff04ed;')
                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 0&&scope.row.handleStatus==0 " content='交办', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-xuanxiangkuangqueding.tabBtn(@click="jiaobanShowDialog(scope.row.id)", style='color:#000;')

                                            el-tooltip.item(effect='light', v-if=" scope.row.ytblButtonFlag === 1 || scope.row.approvalStatus == 3 " content='办理', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-shenqingkaiban.tabBtn(@click="banliShowDialog(scope.row.id)", style='color:red;')

                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 2 || scope.row.approvalStatus == 5 || scope.row.approvalStatus == 7 || scope.row.approvalStatus == 13" content='办理记录', placement='top-start', style='fontWeight:bold')
                                                button.el-icon-tickets.tabBtn(@click="banlijiluShowDialog(scope.row.id)", style='color:blue;')

                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 2 || scope.row.approvalStatus == 6" content='公示', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-querenfangan.tabBtn(@click="gongshiShowDialog(scope.row.id)", style='color:#000;')
                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 13" content='公示打印', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-querenfangan.tabBtn(@click="gongshiShowDialog1(scope.row.id)", style='color:#000;')

                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 5" content='公示记录', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-change-consulta.tabBtn(@click="gongshojiluShowDialog(scope.row.id)", style='color:#dd3020;')

                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 12" content='评议', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-jingcaishike.tabBtn(@click="pingyiShowDialog(scope.row.id)", style='color:#ff34ed;')

                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 13" content='评议打印', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-jingcaishike.tabBtn(@click="pingyiShowDialog1(scope.row.id)", style='color:#ff34ed;')

                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 16" content='议题结果', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-Message.tabBtn(@click="jieguoShowDialog(scope.row.id,'ytjieguo')", style='color:#9da09c;')

                                            //- el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 12" content='评议汇总', placement='top-start', style='fontWeight:bold')
                                            //-     button.iconfont.el-icon-document.tabBtn(@click="pingyihuizongShowDialog(scope.row.id)", style='color:#9da09c;')

                                            el-tooltip.item(effect='light', v-if="scope.row.approvalStatus == 11" content='公示审核', placement='top-start', style='fontWeight:bold')
                                                button.iconfont.icon-shenhe.tabBtn(@click="gongshishenheShowDialog(scope.row.id)", style='color:#ff94ed;')

                                            el-tooltip.item( effect='light',v-if="scope.row.delButtonFlag == 1" content='删除', placement='top-start')
                                                button.iconfont.icon-icon7.tabBtn(@click='showdeletepanduan(scope.row.id)', style='color:#dd3020;')
                                            //- 审批同意后 不显示
                                        //- template( v-if="scope.row.approvalStatus == '1'" )
                                        //-     // 延迟时间 审批同意&尚未开始会议
                                        //-     el-tooltip.item(  effect='light', content='延迟会议时间', placement='top-start', style='fontWeight:bold')
                                        //-         button.iconfont.icon-xuanxiangkuangqueding.tabBtn(@click="showDialog(scope.row.id,'delay')", style='color:#2e99cf;')

                                        //-         // 签到表 审批同意&(商议中||结束)
                                        //-     el-tooltip.item(  effect='light', content='签到表', placement='top-start', style='fontWeight:bold')
                                        //-         button.iconfont.icon-shenqingkaiban.tabBtn(@click="showDialog(scope.row.id,'sign')", style='color:#33ec05;')
 
                                        //-     el-tooltip.item(effect='light', content='协商结果', placement='top-start')
                                        //-         button.el-icon-tickets.tabBtn(@click="showDialog(scope.row.id,'result')", style='color: #321ab9;font-size: 20px;')

                                        //-     el-tooltip.item(effect='light', content='协商结果核实', placement='top-start')
                                        //-         button.iconfont.icon-querenfangan.tabBtn(@click="showDialog(scope.row.id,'resultSummary')", style='color:#9da09c;')

                                        //-     el-tooltip.item(effect='light', content='重新协商', placement='top-start')
                                        //-         button.iconfont.icon-change-consulta.tabBtn(@click="showDialog(scope.row.id,'detail')", style='color:#9da09c;')

                                        //-     el-tooltip.item(effect='light', content='重新发送短信', placement='top-start')
                                        //-         button.tabBtn.iconfont.icon-Message(@click="showDialog(scope.row.id,'showMessage')", style='color:#9da09c;')

                                        //-     el-tooltip.item(effect='light', content='精彩案例', placement='top-start')
                                        //-         button.iconfont.icon-jingcaishike.tabBtn(@click="setCaseGood(scope.row.id)", style='color:#67cef5;')


                            el-pagination(@size-change='handleSizeChange', @current-change='handleCurrentChange', :current-page='pageConfig.pageNo' :page-size='pageConfig.pageSize', layout='total, prev, pager, next, jumper', :total='pageConfig.total')
    // 弹出框新增/编辑/审批
    el-dialog(:title='dialogTitle', :visible.sync='showadd', width='1000px',@close="dialogReturn")
        //- ViewAudit(ref='viewAudit', :rowid='rowid', :readonly='false' , @func='dialogReturn')
        ViewAdd(ref='viewAdd', :rowid='rowid',:show="showadd" @func='dialogReturn')
    el-dialog(title='查看', :visible.sync='showcheck', width='1100px',@close="dialogReturn")
        ViewAudit(ref='viewDetail', :rowid='rowid', :readonly='true' , @func='dialogReturn')
    el-dialog(:title='dialogTitle', :visible.sync='showaudit', width='1100px',@close="dialogReturn")
        ViewAudit(ref='viewAudit', :rowid='rowid', :readonlyadd='readonlys' , @func='dialogReturn')

        
    el-dialog(title='延迟会议', :visible.sync='showDelay', width='1100px',@close="dialogReturn")
        ViewDelay(ref='viewDelay', :rowid='rowid', @func='dialogReturn')
    el-dialog(title='签到表', :visible.sync='showSign', width='1100px',@close="dialogReturn")
        ViewSign(ref='viewSign', :rowid='rowid', @func='dialogReturn')
    el-dialog(title='协商结果', :visible.sync='showResult', width='1100px',@close="dialogReturn")
        ViewResult(ref='viewResult', :rowid='rowid', @func='dialogReturn')
    el-dialog(title='点评', :visible.sync='showReviews', width='1100px',@close="dialogReturn")
        ViewReviews(ref='viewReviews', :rowid='rowid', @func='dialogReturn')
    el-dialog(title='重新发送短息', :visible.sync='showDiaObj.showMessage', width='1100px',@close="dialogReturn")
        sendMessageAgin(ref='sendMessageAgin', :rowid='rowid', @func='dialogReturn')
    el-dialog(title='协商结果核实', :visible.sync='showDiaObj.resultSummary', width='1100px',@close="dialogReturn")
        ViewResult(ref='resultSummary', :rowid='rowid', @func='dialogReturn',:show="showDiaObj.resultSummary")
    // 全流程查看
    el-dialog(title='查看', :visible.sync='showViewProcessAll', width='1100px') 
        ViewProcessAll(:show="showJiaoBan" ref="ViewProcessAll" :ytid='ytid' @close="closeViewProcessAll")
    // 交办
    el-dialog(title='交办', :visible.sync='showJiaoBan', width='1100px') 
        ViewJiaoban(:show="showJiaoBan" ref="ViewJiaoban" :ytid='ytid' @close="closeViewJiaoban")
    // 办理
    el-dialog(title='议题办理', :visible.sync='showBanLi', width='1100px')
        ViewBanLi(:show="showBanLi" ref="ViewBanLi" :ytid='ytid' @close="closeViewBanLi")
    el-dialog(title='办理结果', :visible.sync='showJieGuo', width='1100px')
        ViewJieGuo(:show="showJieGuo" ref="ViewJieGuo" :ytid='ytid' @close="closeViewJieGuo")
    el-dialog(title='办理记录', :visible.sync='showBanLiJiLu', width='1100px')
        ViewBanLiJiLu(ref="ViewBanLiJiLu", :show="showBanLiJiLu" :ytid='ytid')
    el-dialog(title='打印公示表', :visible.sync='showGongShi', width='1100px')
        ViewGongShi(ref='ViewGongShi',:show="showGongShi" :ytid='ytid' @close="closeViewGongShi")
    el-dialog(title='公示记录', :visible.sync='showGongShiJiLu', width='1100px')
        ViewGongShiJiLu(ref="ViewGongShiJiLu",:show="showGongShiJiLu" :ytid='ytid' @close="closeViewGongShiJiLi")
    el-dialog(title='打印评议表', :visible.sync='showPingYi', width='1100px')
        ViewPingYi(ref="ViewPingYi",:show="showPingYi" :ytid='ytid'  @close="closeViewPingYi")

    el-dialog(title='评议汇总', :visible.sync='showPingYiHuiZong', width='1100px')
        ViewPingYiHuiZong(ref="ViewPingYiHuiZong",:show="showPingYiHuiZong" :ytid='ytid' @close="closeViewPingYiHuiZong")

    el-dialog(title='公示审核', :visible.sync='showGongShiShenHe', width='1100px')
        ViewGongShiShenHe(ref="ViewGongShiShenHe",:show="showGongShiShenHe" :ytid='ytid' @close="closeViewGongShiShenHe")
    el-dialog(title='评议审核', :visible.sync='showPingYiShenHe', width='1100px')
        ViewPingYiShenHe(ref="ViewPingYiShenHe",:show="showPingYiShenHe" :ytid='ytid'  @close="closeViewPingYiShenHe")

    el-dialog(title='打印公示表', :visible.sync='showGongShi1', width='1100px')
        ViewGongShi1(ref="ViewGongShi1" :show="showGongShi1" :ytid='ytid' @close="closeViewGongShi1")
    //- el-dialog(title='公示记录', :visible.sync='showGongShiJiLu1', width='1100px')
    //-     ViewGongShiJiLu1(ref="ViewGongShiJiLu1" :show="showGongShiJiLu1" :ytid='ytid' @close="closeViewGongShiJiLi1")
    el-dialog(title='打印评议表', :visible.sync='showPingYi1', width='1100px')
        ViewPingYi1(ref="ViewPingYi1" :show="showPingYi1" :ytid='ytid'  @close="closeViewPingYi1")

</template>

<script>
import {getLoginUserInfo} from "@/api/requrestHttp";
import { tabdata } from "@/mixins/tabledataMix.js";
import echarts_msg from "../../../utils/echarts.js";
import {
  consulApi,
  getConsulType, 
} from "@/api/http.js";
import ViewAdd from "./communityIssueTitle/addDialog.vue";
import ViewDetail from "./communityIssueTitle/detailDialog.vue";
import ViewDelay from "./communityIssueTitle/delayDialog.vue";
import ViewResult from "./communityIssueTitle/resultDialog.vue";
import ViewSign from "./communityIssueTitle/signDialog.vue";
import ViewReviews from "./communityIssueTitle/reviewsDialog.vue";
import sendMessageAgin from "./communityIssueTitle/sendMessageAgin.vue";
// 办理
import ViewAudit from "@/views/platform/gridding/communityIssueTitle/auditDialog.vue";
import ViewProcessAll from "@/views/platform/gridding/communityIssueTitle/liucheng/consultProcessAll.vue";
import ViewJiaoban from "@/views/platform/gridding/communityIssueTitle/liucheng/consultProcessjiaoban.vue";
import ViewBanLi from "@/views/platform/gridding/communityIssueTitle/liucheng/consultProcessbanli.vue";
import ViewJieGuo from "@/views/platform/gridding/communityIssueTitle/liucheng/consultProcessjieguo.vue";
import ViewGongShi from "@/views/platform/gridding/communityIssueTitle/liucheng/consultProcessgongshi.vue";
import ViewPingYi from "@/views/platform/gridding/communityIssueTitle/liucheng/consultProcesspingyi.vue";
import ViewBanLiJiLu from "./communityIssueTitle/showJiaobanjiluDialog.vue";
import ViewGongShiJiLu from "./communityIssueTitle/showGongShiJiLuDialog.vue";
import ViewPingYiHuiZong from "./communityIssueTitle/showPingYiHuiZongDialog.vue";
import ViewGongShiShenHe from "./communityIssueTitle/showGongShiShenHeDialog.vue";
import ViewPingYiShenHe from "./communityIssueTitle/showPingYiShenHeDialog.vue";
// 回显
import ViewGongShi1 from "./communityIssueTitle/showGongShiDialog1.vue";
// import ViewGongShiJiLu1 from "./communityIssueTitle/showGongShiJiLuDialog1.vue";
import ViewPingYi1 from "./communityIssueTitle/showPingYiDialog1.vue";
import { post } from "@/api/requrestHttp";
import request from "../../../utils/request.js";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  mixins: [tabdata],
  components: {
    ViewAdd,
    ViewDetail,
    ViewAudit,
    ViewJieGuo,
    ViewDelay,
    ViewResult,
    ViewSign,
    ViewReviews,
    sendMessageAgin,
    ViewBanLi,
    ViewJiaoban,
    ViewBanLiJiLu,
    ViewGongShi,
    ViewGongShiJiLu,
    ViewPingYi,
    ViewPingYiHuiZong,
    ViewGongShiShenHe,
    ViewPingYiShenHe,
    ViewGongShi1,
    ViewProcessAll,
    ViewPingYi1
  },
  data() {
    return {
      ytlxtList:[],
      readonlys:true,
      readonlyjb:true,
      readonlybl:false,
      readonlyjg:false,
      readonlygs:false,
      readonlypy:false,
      showJiaoBan: false,
      showBanLi: false,
      showJieGuo: false,
      showBanLiJiLu: false,
      showGongShi: false,
      showGongShiJiLu: false,
      showViewProcessAll:false,
      showPingYi: false,
      showPingYiHuiZong: false,
      showGongShiShenHe: false,
      showPingYiShenHe: false,
      showGongShi1: false,
      // showGongShiJiLu1: false,
      showPingYi1: false,
      approvalStatusTextObj: {
        0: "待审批",
        1: "同意",
        2: "不同意"
      },
      ytid: '',
      showKeys: [],
      searchTypes1: [],
      searchTypes2: [],
      //按需查询
      queryTime: [],
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      myChart_1_1: null,
      myChart_1_2: null,
      myChart_1_3: null,
      // 新增弹出层
      dialogTitle: "弹框",
      dialogFlag: "",
      rowid: "",
      showadd: false,
      readonlys:false,
      checkpeop: false,
      showcheck: false,
      showaudit: false,
      showDelay: false,
      showSign: false,
      showResult: false,
      showReviews: false,
      showDiaObj: {
        resultSummary: false,
        showMessage: false
      },

      //是否刷新token
      needRef: false,
      mllbList: [],
      orgLevel: ''
    };
  },
  created() {
    this.initTableDataUrl("/admin/consult/info/findConsultList");
    getLoginUserInfo({
      id: this.$store.state.id
    }).then(res => { 
      this.orgLevel = res.content.user.orgLevel;
    });
  },
  methods: {
    issueCJ() {
        this.moduleShow1 = true;
        this.moduleShow2 = false;
        this.moduleShow3 = false;
        this.moduleShow4 = false;
        this.moduleShow5 = false;
        this.moduleShow6 = false;
    },
    jbinfo() {
        this.moduleShow1 = false;
        this.moduleShow2 = true;
        this.moduleShow3 = false;
        this.moduleShow4 = false;
        this.moduleShow5 = false;
        this.moduleShow6 = false;
        post("admin/consult/info/findConsultById",{
            id: this.ytid,
        }).then(res => {
            this.jiaobanform = res.content;
        })
    },
    blinfo() {
        this.moduleShow1 = false;
        this.moduleShow2 = false;
        this.moduleShow3 = true;
        this.moduleShow4 = false;
        this.moduleShow5 = false;
        this.moduleShow6 = false;
        this.getConsultList();
    },
    blresult() { //结果
        this.moduleShow1 = false;
        this.moduleShow2 = false;
        this.moduleShow3 = false;
        this.moduleShow4 = true;
        this.moduleShow5 = false;
        this.moduleShow6 = false;
        this.getConsultList();
    },
    blpublicity() { //公示
        this.moduleShow1 = false;
        this.moduleShow2 = false;
        this.moduleShow3 = false;
        this.moduleShow4 = false;
        this.moduleShow5 = true;
        this.moduleShow6 = false;
        this.getConsultList();
    },
    blComment() { //公示
        this.moduleShow1 = false;
        this.moduleShow2 = false;
        this.moduleShow3 = false;
        this.moduleShow4 = false;
        this.moduleShow5 = false;
        this.moduleShow6 = true;
        this.getConsultList();
    },
    closeViewProcessAll() {
      this.showViewProcessAll = false;
      this.getPageDatas();
      
    },
    closeViewJiaoban() { 
      this.showJiaoBan = false;
      this.getPageDatas();
      
    },
    closeViewBanLi() {
      this.showBanLi = false;
      this.getPageDatas();
    },
    closeViewJieGuo() {
      this.showJieGuo = false;
      this.getPageDatas();
    },
    closeViewGongShi() {
      this.showGongShi = false;
      this.getPageDatas();
    },
    closeViewGongShi1() {
      this.showGongShi1 = false;
      this.getPageDatas();
    },
    closeViewGongShiJiLi() {
      this.showGongShiJiLu = false;
      this.getPageDatas();
    },
    // closeViewGongShiJiLi1() {
    //   this.showGongShiJiLu1 = false;
    //   this.getPageDatas();
    // },
    closeViewPingYiHuiZong() {
       this.showPingYiHuiZong = false;
      this.getPageDatas();
    },
    closeViewGongShiShenHe() {
      this.showGongShiShenHe = false;
      this.getPageDatas();
    },
    closeViewPingYiShenHe() {
       this.showPingYiShenHe = false;
      this.getPageDatas();
    },
    closeViewPingYi() {
      this.showPingYi = false;
      this.getPageDatas();
    },
    closeViewPingYi1() {
      this.showPingYi1 = false;
      this.getPageDatas();
    },
    getConsultType(){
      post("/admin/consulType/info/findConsultTypeList",{
            pageSize:999,
            pageNo:1,
        }).then(res => { 
          if (res.code == 200) {
            this.ytlxtList = res.content.list; 
          }
        })
    },
    // 查看点击事件
    liucAllShowDialog(id) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$set(this, "ytid", id)
          this.showViewProcessAll = true;
          this.$refs.ViewProcessAll.issueCJ();
          // this.$refs.ViewJiaoban.getFindConsultPersonList();
          // this.$refs.ViewJiaoban.getListConsultOrg();
        })
      }, 100)
    },
    // 交办点击事件
    jiaobanShowDialog(id) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$set(this, "ytid", id)
          this.showJiaoBan = true;
          this.$refs.ViewJiaoban.jbinfo();
          // this.$refs.ViewJiaoban.getFindConsultPersonList();
          // this.$refs.ViewJiaoban.getListConsultOrg();
        })
      }, 100)
    },
    banliShowDialog(id) {
      this.showBanLi = true;
      this.$set(this, "ytid", id);
      this.$nextTick(() => {
        if (this.$refs.ViewBanLi !== undefined) {
          this.$refs.ViewBanLi.blbanli();
          this.$refs.ViewBanLi.getConsultList();
          }
      })
    },
    jieguoShowDialog(id) {
      this.showJieGuo = true;
      this.$set(this, "ytid", id);
      this.$nextTick(() => {
        if (this.$refs.ViewJieGuo !== undefined) {
          this.$refs.ViewJieGuo.blresult(); 
          }
      })
    },
    banlijiluShowDialog(id) {
      this.$set(this,"ytid", id)
      this.showBanLiJiLu = true;
      this.$nextTick(() => {
      if (this.$refs.ViewBanLiJiLu !== undefined) {
          this.$refs.ViewBanLiJiLu.getData()
          this.$refs.ViewBanLiJiLu.getFindConsultHandleList();
          this.$refs.ViewBanLiJiLu.getFindConsultById();
          }
      })
    },
    gongshiShowDialog(id) {
      this.$set(this,"ytid", id)
      this.showGongShi = true;
      this.$nextTick(() => {
        if (this.$refs.ViewGongShi !== undefined) {
          this.$refs.ViewGongShi.blpublicity(); 
          }
       })
    },
    gongshiShowDialog1(id) {
       this.$set(this,"ytid", id)
      this.showGongShi1 = true;
      this.$nextTick(() => {
        if (this.$refs.ViewGongShi1 !== undefined) {
          this.$refs.ViewGongShi1.getGongShiInfo();
          }
       })
    },
    gongshojiluShowDialog(id) {
      this.$set(this,"ytid", id)
      this.showGongShiJiLu = true;
      this.$nextTick(() => {
        if (this.$refs.ViewGongShiJiLu !== undefined) {
          this.$refs.ViewGongShiJiLu.getData();
          }
       })
      
    },
    // gongshojiluShowDialog1(id) {
    //   this.$set(this,"ytid", id)
    //   this.showGongShiJiLu1 = true;
    //   this.$nextTick(() => {
    //     if (this.$refs.ViewGongShiJiLu1 !== undefined) {
    //       this.$refs.ViewGongShiJiLu1.getConsultPublicity();
    //       }
    //    })
    // },
    pingyiShowDialog(id) {
      this.$set(this,"ytid", id) 
      this.$nextTick(() => {
        if (this.$refs.ViewPingYi !== undefined) {
          this.$refs.ViewPingYi.blComment();
        }
      })
      this.showPingYi = true;
    },
    pingyiShowDialog1(id) {
      this.$set(this,"ytid", id)
      this.showPingYi1 = true;
      this.$nextTick(() => {
      if (this.$refs.ViewPingYi1 !== undefined) {
        this.$refs.ViewPingYi1.getData();
        this.$refs.ViewPingYi1.getFindConsultById();
        this.$refs.ViewPingYi1.getConsultComment();
        }
      })
    },
    pingyihuizongShowDialog(id) {
      this.$set(this,"ytid", id)
      this.showPingYiHuiZong = true;
      this.$refs.ViewPingYiHuiZong.getData();
    },
    gongshishenheShowDialog(id) {
      this.$set(this,"ytid", id)
      this.$nextTick(() => {
        if (this.$refs.ViewGongShiShenHe !== undefined) {
          this.$refs.ViewGongShiShenHe.getData();
          this.$refs.ViewGongShiShenHe.getFindConsultById();
          this.$refs.ViewGongShiShenHe.getSjjl();
          }
      })
      this.showGongShiShenHe = true;
    },
    pingyishenheShowDialog(id) {
      this.$set(this,"ytid", id)
      this.$nextTick(() => {
        if (this.$refs.ViewPingYiShenHe !== undefined) {
          this.$refs.ViewPingYiShenHe.getConsultComment();
          this.$refs.ViewPingYiShenHe.getData();
          }
      })
      this.showPingYiShenHe = true;
      
    }, 
    //获取条件查询的议题分类
    async getPTypes() {
      let fd = new FormData();
      fd.append("token", token);
      let params = JSON.stringify({ parentId: 0 });
      fd.append("consultType", params);

      var res = await getConsulType(fd);
      var temp = {};
      if (res.content && res.content.length > 0) {
        res.content.forEach(item => {
          temp = { id: item.id, value: item.id, label: item.consultName };
          this.searchTypes1.push(temp);
        });
      }
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    searchlistReset() {
      this.searchlist = {};
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    handleSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    // 图表加载函数
    async drawChart() {
      let fd = new FormData();
      fd.append("token", token);
      var res = await consulApi.consultStatistics(fd)
      if (res.code == 200) {
        //按议题类型查看 柱状图
        var option_1_1_text = [];
        var option_1_1_data = [];
        if (res.content.type) {
          res.content.type = res.content.type.filter(it => !!it.typeName);
          res.content.type.forEach((item, index) => {
            // item.typeName = item.typeName || "暂无";
            option_1_1_text.push(item.typeName);
            option_1_1_data.push(item.number);
          });
        }
        var option_1_3_text = [];
        var option_1_3_data1 = []; 
        if (res.content.issueSource) {
          res.content.issueSource = res.content.issueSource.filter(it => !!it.number);
          res.content.issueSource.forEach((item, index) => {
            // item.typeName = item.typeName || "暂无";
            option_1_3_text.push(item);
            option_1_3_data1.push(item.number);
          });
        }

        var myChart_1_1 = this.$echarts.init(
          document.getElementById("chart_1_1")
        );
        // var option_1_1 = echarts_msg.option_bar;
        var option_1_1 = JSON.parse(JSON.stringify(echarts_msg.option_bar));
        option_1_1.axisLabel = {
          color: "#000",
          interval: 0,
          formatter: function(value) {
            if (value.length > 12) {
              return value.substring(0, 5) + "...";
            } else {
              return value;
            }
          }
        };
        option_1_1.title.text = "";
        option_1_1.xAxis.type = "value";
        option_1_1.yAxis.type = "category";
        option_1_1.yAxis.data = option_1_1_text;

        option_1_1.series[0].itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(
          0,
          0,
          1,
          0,
          [
            { offset: 0, color: "#ff8383" },
            { offset: 1, color: "#ffe5e6 " }
          ]
        );
        option_1_1.series[0].data = option_1_1_data;
        myChart_1_1.setOption(option_1_1);

        /****    协商来源     S           */

        var option_1_3_data = [
          { value: option_1_3_data1[1], name: "党小组、村(居)民组会议" },
          { value: option_1_3_data1[2], name: "群众通过电话或口头等方式" },
          { value: option_1_3_data1[3], name: "群众通过微信、QQ等方式提出" },
          { value: option_1_3_data1[4], name: "党员议事日" },
          { value: option_1_3_data1[5], name: "意见箱" },
          { value: option_1_3_data1[6], name: "包组干部收集到群众的需求" },
          { value: option_1_3_data1[7], name: "落实上级党委政府工作安排" },
          { value: option_1_3_data1[8], name: "其他" }
        ]; ;
        var myChart_1_3 = this.$echarts.init(
          document.getElementById("chart_1_3")
        );
        var option_1_3 = {
          title: {
            text: "",
            subtext: "",
            left: "center"
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: "horizontal",
            bottom: 0,
            data: []
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: "55%",
              center: ["50%", "50%"],
              data: [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        }; 
        option_1_3.series[0].data = option_1_3_data;
        console.log(option_1_3.series[0].data)

        myChart_1_3.setOption(option_1_3);

        /****    协商来源     E           */

        //按组织查看 柱状图
        var option_1_2_text = [];
        var option_1_2_data = [];
        if (res.content.org) {
          res.content.org.forEach((item, index) => {
            item.orgName = item.orgName || "暂无";
            option_1_2_text.push(item.orgName);
            option_1_2_data.push(item.number);
          });
        }
        var myChart_1_2 = this.$echarts.init(
          document.getElementById("chart_1_2")
        );
        var option_1_2 = echarts_msg.option_bar;
        option_1_2.title.text = "";
        option_1_2.xAxis.type = "value";
        option_1_2.yAxis.type = "category";
        option_1_2.yAxis.data = option_1_2_text;
        option_1_2.series[0].itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(
          0,
          0,
          1,
          0,
          [
            { offset: 0, color: "#45b6e7" },
            { offset: 1, color: "#45b6e75c" }
          ]
        );
        option_1_2.series[0].data = option_1_2_data;
        myChart_1_2.setOption(option_1_2);

        window.addEventListener("resize", () => {
          myChart_1_1.resize();
          myChart_1_2.resize();
          myChart_1_3.resize();
        });

        //关键词赋值 最多15个关键词
        this.showKeys = res.content.keyWord;
      } else {
        // console.log(res);
        this.$message({
          message: "统计图加载异常：",
          type: "error"
        });
      }
    },
    //弹框控制
    showDialog(id = '', flag, row) {
      this.$set(this, "rowid", id);
      this.dialogFlag = flag;
      if (flag == "add") {
        this.showadd = true;
        this.dialogTitle = id != "" ? "编辑" : "议题采集";
        this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          if (this.$refs.viewAdd !== undefined) {
            this.$refs.viewAdd.id = this.rowid;
            this.$refs.viewAdd.getData({"row": '', "status":false});
            this.$refs.viewAdd.getOrgLevel();
          }
        });
      } else if (flag == "detail") {
        this.showadd = true;
        this.dialogTitle = "查看";
        this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          if (this.$refs.viewAdd !== undefined) {
            this.$refs.viewAdd.id = this.rowid;
            this.$refs.viewAdd.getData({"row": row, "status":true});
            this.$refs.viewAdd.getOrgLevel();
          }
        });
        // this.showcheck = true;
        // this.readonlys = true;
        // this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          // if (this.$refs.viewDetail !== undefined) {
          //   this.$refs.viewDetail.id = this.rowid;
          //   this.$refs.viewDetail.getData();
          //   this.$refs.viewDetail.getFindConsultById();
          // }
        // });
      } else if (flag == "audit") {
        this.showadd = true;
        this.dialogTitle = "编辑";
        this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          if (this.$refs.viewAdd !== undefined) {
            this.$refs.viewAdd.id = this.rowid;
            this.$refs.viewAdd.getData({"row": row, "status":false});
            this.$refs.viewAdd.getOrgLevel();
          }
        });
        // return
        // this.showaudit = true;
        // // this.$nextTick(() => {
        //   //解决子组件数据无法刷新问题
        //   // if (this.$refs.viewAudit !== undefined) {
        //     this.$refs.viewAudit.id = this.rowid;
        //     this.$refs.viewAudit.getData();
        //     this.$refs.viewAudit.getFindConsultById();
        //   // }
        // // });
      } else if (flag == "sign") {
        this.showSign = true;
        this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          if (this.$refs.viewSign !== undefined) {
            this.$refs.viewSign.id = this.rowid;
            this.$refs.viewSign.getData();
          }
        });
      } else if (flag == "delay") {
        this.showDelay = true;
        this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          if (this.$refs.viewDelay !== undefined) {
            this.$refs.viewDelay.id = this.rowid;
            this.$refs.viewDelay.getData();
          }
        });
      } else if (flag == "result") {
        this.showResult = true;
        this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          if (this.$refs.viewResult !== undefined) {
            this.$refs.viewResult.id = this.rowid;
            this.$refs.viewResult.getData();
          }
        });
      } else if (flag == "reviews") {
        this.showReviews = true;
        this.$nextTick(() => {
          //解决子组件数据无法刷新问题
          if (this.$refs.viewReviews !== undefined) {
            this.$refs.viewReviews.id = this.rowid;
            this.$refs.viewReviews.getData();
          }
        });
      } else {
        console.log('flag',flag)
        this.showDiaObj[flag] = true;
      }
    },
    dialogReturn(flag) {
      //   this.rowid = null;
      this.$set(this, "rowid", "");
      if (this.dialogFlag == "add") {
        this.showadd = false;
        this.pageConfig.pageNo = 1;
        this.getPageDatas();
      } else if (this.dialogFlag == "detail") {
        this.showadd = false;
      } else if (this.dialogFlag == "audit") {
        this.showadd = false;
        this.getPageDatas();
      } else if (this.dialogFlag == "sign") {
        this.showSign = false;
        this.getPageDatas();
      } else if (this.dialogFlag == "delay") {
        this.showDelay = false;
        this.getPageDatas();
      } else if (this.dialogFlag == "result") {
        this.showResult = false;
        this.getPageDatas();
      } else if (this.dialogFlag == "reviews") {
        this.showReviews = false;
        this.getPageDatas();
      } else {
        this.showDiaObj[flag] = false;
        this.getPageDatas();
      }
    }, 
    //删除操作
    // async showdeletepanduan(id) {
    //   this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(async () => {
    //       let fd = new FormData();
    //       fd.append("token", token);
    //       fd.append("id", id);

    //       var res = await consulApi.delete(fd);
    //       if (res.code == 200) {
    //         this.$message({
    //           message: "删除成功",
    //           type: "success"
    //         });
    //         this.pageConfig.pageNo = 1;
    //         this.getPageDatas();
    //       } else {
    //         console.log(res);
    //         this.$message({
    //           message: "删除失败：" + res.message,
    //           type: "error"
    //         });
    //       }
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消删除"
    //       });
    //     });
    // },
    // 删除操作
    showdeletepanduan(id) {
        this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
        }).then(() => {
          post("/admin/consult/info/deleteConsult",{
            id: id
          }).then(res => {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.pageConfig.pageNo = 1;
            this.getPageDatas();
          }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
        })
    },
    //精彩案例
    // async setCaseGood(id) {
    //   this.$confirm("是否设置为精彩案例?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(async () => {
    //       let fd = new FormData();
    //       fd.append("token", token);
    //       fd.append("id", id);
    //       //   var res = await request({
    //       //     url: "/admin/consul/info/deleteConsult",
    //       //     method: "POST",
    //       //     data: fd
    //       //   });

    //       var res = await consulApi.delete(fd);
    //       if (res.code == 200) {
    //         this.$message({
    //           message: "设置成功",
    //           type: "success"
    //         });
    //         this.pageConfig.pageNo = 1;
    //         this.getPageDatas();
    //       } else {
    //         console.log(res);
    //         this.$message({
    //           message: "设置失败：" + res.message,
    //           type: "error"
    //         });
    //       }
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消设置为精彩案例"
    //       });
    //     });
    // },
    formatterConsultType(row, column) {
      let v = "";
      this.searchTypes1.forEach(e => {
        if (e.id == row.consultType) {
          v = e.label;
        }
      });
      return v;
    },
    formatterReportSource(row, column) {
      //   console.log(row);

      let v = "暂无";
      const reportSourceType = {
        1: "平台自建",
        2: "居民上报",
        3: "组织上报",
        4: "专家调研",
        5: "发函征集型"
      };
      if (row.reportSource) return reportSourceType[row.reportSource];
      return v;
    }
  },
  mounted() {
    // 初始化图表加载
    this.drawChart();
    this.getConsultType();
    this.getPTypes(); 
  },
  beforeDestroy() {
    if (this.myChart_1_1) {
      this.myChart_1_1.clear();
    }
    if (this.myChart_1_2) {
      this.myChart_1_2.clear();
    }
    if (this.myChart_1_3) {
      this.myChart_1_3.clear();
    }
  }
};
</script>

<style lang="less">
.line_box {
  align-items: center;
  border-bottom: 1px solid#ddd;
  padding-bottom: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #333;
  font-size: 15px;
  font-weight: 700;
}
</style>
<style lang="less" scoped>
//  包裹两个卡片的盒子
.card-box {
  display: flex;
  // 左边树状列表卡片
  .card-l {
    width: 270px;
  }
  .card-r {
    flex: 1;
    height: 320px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .card-0 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .card-2 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .card-3 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }

    .topbarnav {
      display: flex;
      align-items: center;
      div {
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 14px;
      }
    }
  }
}
.card-4 {
  margin-top: 12px;
}
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
  }
  
}
.threestyleimg {
  display: flex;
  // align-items: center;
  // justify-content: center;
  flex-wrap: wrap;
  .threestyleimgtu {
    width: 80%;
    height: 70%;
    // background-color: red;
    display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .threestyleimgbtn {
    width: 80%;
    height: 30%;
    margin-top: 20px;

    // background-color: green;
    display: flex;
    // justify-content: center;
    // align-items: center;

    position: relative;
    div {
      width: 170px;
      height: 30%;
      background: #ffffff;
      border: 1px solid #cad4dc;
      text-align: center;
      line-height: 30px;
    }
    input {
      position: absolute;
      width: 172px;
      height: 32px;
      opacity: 0;
      cursor: pointer;
    }
  }
}
.queRenBtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  .qubtn{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  } 
  .qubtn :hover{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  }
  .qubtn_span{
      color:#409EFF; 
      margin-top:10px
  }

}
</style>
